import type { Editor } from '@tiptap/react';
import type { PropsWithChildren, RefObject } from 'react';

import {
	TiptapContext,
	TiptapEditor,
} from '@/components/EditableText/TiptapEditor.tsx';
import { cn } from '@/utils/cn.ts';

export type EditableTextProps = {
	text: string;
	placeholder?: string;
	multiline?: boolean;
	charLimit?: number;
	onMount?: (text: string) => void;
	onFocus?: (text: string) => void;
	onEdit?: (newText: string) => void;
	onBlur?: (text: string) => void;
	onEnter?: (text: string) => boolean;
	containerClassName?: string;
	editorClassName?: string;
	placeholderClassName?: string;
	editorRef?: RefObject<Editor | null>;
};

export const EditableText = ({
	text,
	placeholder,
	multiline = true,
	charLimit,
	onMount,
	onFocus,
	onEdit,
	onBlur,
	onEnter,
	containerClassName,
	editorClassName,
	placeholderClassName,
	editorRef,
	children,
}: PropsWithChildren<EditableTextProps>) => {
	return (
		<div className={cn('group relative', containerClassName)}>
			{children}

			<TiptapContext
				editorClassName={editorClassName}
				placeholderClassName={placeholderClassName}
				initialContent={text}
				controlledContent={text}
				multiline={multiline}
				charLimit={charLimit}
				placeholder={placeholder}
				onMount={onMount}
				onFocus={onFocus}
				onEdit={onEdit}
				onBlur={onBlur}
				onEnter={onEnter}
				editorRef={editorRef}
			>
				<TiptapEditor />
			</TiptapContext>
		</div>
	);
};
